import React, { useEffect, useState } from 'react';
import { Box, Container, Typography } from '@mui/material';
import PageHeader from '../../common/PageHeader';
import { AdminPageDetails, PageDetails } from '../config';
import { getData } from '../../../DataAccessLayer';
import { sam } from '../../../DataAccessLayer/services';
import PortalDataGridPro from '../../common/PortalDataGridPro';
import { getColumns } from './columns';
import { JobProcessingBanner } from '../JobProcessingBanner';

export const RulesUpdateReport = () => {
  const [id] = useState('rulesUpdateReport');
  const [title, setTitle] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [rulesUpdateHistory, setRulesUpdateHistory] = useState([]);

  //θ(N) where N is the number of pages in PageDetails
  //Retrieve page title from pageDetails using pageid
  const loadPageTitle = () => {
    const page = Object.values(AdminPageDetails).find((page) => page.id === id);

    setTitle(page.title);
  };

  const getRulesUpdateHistory = async () => {
    setIsLoading(true);
    try {
      const data = await getData(sam.advisorRules().getAll, true);

      setRulesUpdateHistory(data);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadPageTitle();
    getRulesUpdateHistory();
  }, []);

  return (
    <>
      <div id={`${id}__div_pageWrapper`} className={`myOdu__${id}`} style={{}}>
        <Container id={`${id}__container_pageWrapper`} className="myOdu__container secondaryPage">
          <PageHeader
            id={id}
            title={title}
            isSubPage
            pageConfig={{ ...PageDetails, ...AdminPageDetails }}
          />
          <JobProcessingBanner />

          <Box id={`${id}__box_wrapper`}>
            <PortalDataGridPro
              rows={rulesUpdateHistory}
              getRowId={(row) => row.CREATED_AT}
              columns={getColumns(rulesUpdateHistory)}
              isLoading={isLoading}
              pagination
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 20,
                    page: 0,
                  },
                },
              }}
              disableRowSelectionOnClick
              slotProps={{
                loadingOverlay: {
                  noRowsVariant: 'skeleton',
                },
              }}
              slots={{
                noRowsOverlay: () => {
                  return (
                    <Box mt={1} display="flex" justifyContent="center">
                      <Typography variant="p" component="p">
                        No rules update records found.
                      </Typography>
                    </Box>
                  );
                },
              }}
            />
          </Box>
        </Container>
      </div>
    </>
  );
};
